import { createMutation } from "@/mutations";
import { uploadImage } from "@/features/search/api/search";
import type { UploadImageResponse } from "@/types/searchItemsTypes";

export interface UploadImageVariables {
  file: File | Blob;
}

export const useUploadSearchImageMutation = () => {
  return createMutation<UploadImageResponse, UploadImageVariables>({
    mutationFn: async ({ file }) => {
      const response = await uploadImage(file);
      return response.data as UploadImageResponse;
    },
  });
};

